module.exports = __webpack_public_path__ + "img/no-reward.ff0cb627.png";